module.exports = __webpack_public_path__ + "static/media/danger.8138dc11.png";